import Component from '../component/component';

import './main.scss';

export default class Main extends Component {
    static initSelector: string = '.main';

    public container: JQuery;
    public sections: JQuery;
    public lastY: number;
    public direction: string;
    public currentTheme: string;

    constructor(target: HTMLElement) {
        super(target);

        this.container = $('body');
        this.sections = this.element.find('.section');
        this.lastY = $(window).scrollTop();
        this.currentTheme = 'none';
        this.direction = 'none';

        this.init();
    }

    init(): void {
        this.getFirstTheme();
        this.scroll();

        $(document).on('scroll', this.scroll.bind(this));
    }

    scroll(): void {
        const currY: number = $(window).scrollTop();
        const primarySection: HTMLElement = this.getPrimarySection();

        this.direction = (currY > this.lastY) ? 'down' : ((currY === this.lastY) ? 'none' : 'up');
        this.sections = this.element.find('.section');

        if (currY > 10) {
            this.container.addClass('has-scrolled');
        } else {
            this.container.removeClass('has-scrolled');
        }

        // for changing background color:
        if (primarySection) {
            const newTheme: string = this.getSectionTheme(primarySection);

            if (this.currentTheme !== newTheme) {
                this.currentTheme = this.getSectionTheme(primarySection);

                this.removeClass();
                this.container.addClass(this.getThemeClass(this.currentTheme));
            }
        }

        // update last scroll position to current position
        this.lastY = currY;
    }

    getFirstTheme(): void {
        const firstTheme: string = this.sections.first().data('theme');

        this.removeClass();

        if (firstTheme) {
            this.container.addClass(this.getThemeClass(firstTheme));
        }
    }

    removeClass(): void {
        this.container.removeClass((_index: number, css: string) =>
            (css.match(/\btheme-\S+/g) || []).join(' '), // removes everything that starts with "theme-"
        );
    }

    getPrimarySection(): HTMLElement {
        let primarySection: HTMLElement;

        this.sections.each((_index: number, element: HTMLElement) => {
            if (this.isOnSectionStart($(element))) {
                primarySection = element;
            }
        });

        return primarySection;
    }

    getSectionTheme(section: HTMLElement): string {
        return $(section).data('theme');
    }

    getThemeClass(theme: string): string {
        return 'theme-' + theme;
    }

    isOnSectionStart(target: JQuery): boolean {
        const win: JQuery<Window> = $(window);
        const offset: number = this.direction === 'up' ? (win.height() / 3) : (win.height() / 1.8);
        const top: number = target.offset().top;
        const bottom: number = top + target.height();
        const viewTop: number = win.scrollTop() + offset;

        return ((top <= viewTop) && (bottom > viewTop));
    }
}
